<template>
    <div id="visitor-modal" class="modal fade v-visitor-form" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Vous êtes</h4>
                </div>
                <div class="modal-body">
                    <form @submit="submit" class="form">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <div>
                                        <div class="radio">
                                            <label>
                                                <input required="required" name="type" type="radio"
                                                       v-bind:value="type_individual" v-model="vm.type">
                                                Particulier *
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <div>
                                        <div class="radio">
                                            <label>
                                                <input required="required" name="type" type="radio"
                                                       v-bind:value="TYPE_PROFESSIONAL" v-model="vm.type">
                                                Professionnel *
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="vm.type === TYPE_PROFESSIONAL">
                            <div class="col-md-12">
                                <div class="form-group required">
                                    <label for="society_name" class="control-label">Structure à laquelle vous appartenez
                                        : *</label>
                                    <div>
                                        <input required="required" class="form-control" id="society_name"
                                               name="society_name" type="text" v-model="vm.society_name">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="block-buttons">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">
                                        Fermer
                                    </button>
                                    <button type="submit" class="btn btn-form">
                                        Valider
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from '../services/loader';
    import Alert from '../services/alert';
    import Api from '../services/api';

    const KEY = 'popup-visitor.last.display';
    const TYPE_INDIVIDUAL = 'individual';
    const TYPE_PROFESSIONAL = 'professional';

    export default {
        data() {
            return {
                errors: [],
                TYPE_PROFESSIONAL: TYPE_PROFESSIONAL,
                type_individual: TYPE_INDIVIDUAL,
                vm: this.default()
            }
        },

        mounted() {
            let lastPopup = Vue.ls.get(KEY);

            if (!lastPopup) {
                setTimeout(() => {
                    $(this.$el).modal('show');
                }, 5000);
            }
        },

        methods: {
            default() {
                return {
                    type: null,
                    society_name: null,
                }
            },

            submit(e) {
                let errors = this.checkForm();

                e.preventDefault();

                Loader.show();

                if (typeof errors === 'object' && errors.length) {
                    Loader.hide();

                    Alert.error(errors.join(' <br> '));
                } else {
                    this.save(this.vm)
                        .then(() => {
                            Loader.hide();

                            Vue.ls.set(KEY, new Date().getTime());

                            $(this.$el).modal('hide');
                        })
                        .catch(error => {
                            Loader.hide();

                            Alert.error('Les informations n\'ont pas pu être enregistré.');
                        });
                }
            },

            checkForm() {
                let errors = [];

                if (this.vm.type && ((this.vm.type === TYPE_PROFESSIONAL && this.vm.society_name) || this.vm.type === TYPE_INDIVIDUAL)) {
                    return true;
                }

                if (!this.vm.type || (this.vm.type !== TYPE_PROFESSIONAL && this.vm.type !== TYPE_INDIVIDUAL)) {
                    errors.push('Veuillez sélectionner un type.')
                }

                if (this.vm.type && this.vm.type === TYPE_PROFESSIONAL && !this.vm.society_name) {
                    errors.push('Veuillez sélectionner votre structure.')
                }

                return errors;
            },

            save(data) {
                return new Promise((resolve, reject) => {
                    Api.post('/visitor', data)
                        .then(data => resolve(data))
                        .catch(reject)
                });
            },
        }
    }
</script>

<style lang="scss">
    @import "../../sass/variables";

    .v-visitor-form {
        .modal-dialog {
            margin: 25vh auto;
        }
        .modal-header {
            background-color: $blue-light;
            color: $cerbtpheaderblue;
            .close {
                color: $cerbtpheaderblue;
                opacity: 0.6;
                &:hover {
                    opacity: 1;
                }
            }
        }
        .modal-body {
            .form {
                .form-group {
                    margin-bottom: 25px;
                    .form-control:not(button) {
                        margin-top: 5px;
                        margin-bottom: 5px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/VisitorForm.vue